import { bookingApiPlugin } from '#stores'

import type { Environment } from '@revolugo/common/constants'
import type { Pinia } from 'pinia'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useBookingApi() {
  const runtimeConfig = useRuntimeConfig()
  const nuxtApp = useNuxtApp()
  const pinia = nuxtApp.$pinia as Pinia

  const optionalHeaders: Record<string, string> = {}

  if (runtimeConfig.public.REVOLUGO_ELEMENTS_CONSUMER_CUSTOM_ID) {
    optionalHeaders['x-consumer-custom-id'] =
      runtimeConfig.public.REVOLUGO_ELEMENTS_CONSUMER_CUSTOM_ID
  }

  if (runtimeConfig.public.REVOLUGO_ELEMENTS_GROUPS) {
    optionalHeaders['x-consumer-groups'] =
      runtimeConfig.public.REVOLUGO_ELEMENTS_GROUPS
  }

  pinia.use(
    bookingApiPlugin({
      apiEnvironment: runtimeConfig.public
        .REVOLUGO_BOOKING_API_ENVIRONMENT as Environment,
      apiKey: runtimeConfig.public.REVOLUGO_PUBLISHABLE_API_KEY,
      optionalHeaders,
    }),
  )
}
